export default {
  USER_LOGIN_SUCCESS: 10,
  USER_SIGNUP_SUCCESS: 30,
  ALREADY_REGISTERED: 71,
  INVALID_TOKEN: 72
};
